/* import __COLOCATED_TEMPLATE__ from './char-counter.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./char-counter.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());